<template>
    <v-container class="toggle animated" fluid>
        <v-row dense>
            <v-col cols="12" md="4">
                <v-text-field
                    v-model="search"
                    variant="outlined"
                    prepend-inner-icon="mdi-magnify"
                    label="Search"
                    density="comfortable"
                    solo
                    hide-details
                    rounded="lg"
                    color="primary"
                ></v-text-field>
            </v-col>
            <v-col class="text-right" cols="12" md="8">
                <v-btn
                @click="showAddDialog()"
                prepend-icon="mdi-plus"
                class="mt-1 rounded-lg"
                color="routesColor"
                height="40px"
                elevation="2">
                    Add Announcement
                </v-btn>
            </v-col>
            <v-col cols="12">
                <v-row dense>
                    <v-col cols="12">
                        <v-card class="dt-container mt-2">    
                            <v-data-table
                                :mobile="isMobileOrTablet()"
                                :headers="headers"
                                :items="data"
                                :search="search"
                                :loading="loading"
                                :items-per-page="15"
                                :items-per-page-options="[15,30, 50, 100, -1]"
                            >
                            <template v-slot:loading>
                                <v-progress-linear indeterminate color="primary" height="5" class="mt-1 rounded-lg"></v-progress-linear>
                            </template>
                            <template v-slot:item.details="{ item }">
                                <div class="text-truncate" style="max-width: 300px; white-space: pre-wrap;">
                                    {{ item.details }}
                                </div>
                            </template>
                            <template v-slot:item.is_active="{ item }">
                                <v-chip v-if="item.is_active == true" size="small" color="green" variant="elevated">
                                    Yes
                                </v-chip>
                                <v-chip v-else size="small" color="gray">
                                    No
                                </v-chip>
                            </template>
                            <template v-slot:item.datecreated="{ item }">
                                <span>{{ formatDateTime(item.datecreated)}} </span>
                            </template>
                            <template v-slot:[`item.action`]="{ item }">
                                    <v-btn v-if="item.is_active == false" @click="showActivateDialog(item)" size="small" variant="outlined" text="Activate announcement" color="green-accent-4" elevation="3" class="mr-2"></v-btn>
                                    <v-btn @click="showEditDialog(item)" size="small" variant="outlined" text="Edit" color="orange" elevation="3"></v-btn>
                            </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>

    <v-dialog v-model="confirmActivate" width="450" persistent>
        <v-card color="secondary" rounded="lg" class="pa-2">
            <v-card-text>
                <div class="font-weight-bold mt-2 text-h6">Are you sure you want activate this announcement?</div>
                <div class="font-weight-light mt-2">Note: Once confirmed, This aanouncement will be displayed to the dashboard.</div>
            </v-card-text>
            <template v-slot:actions>
            <v-spacer></v-spacer>

            <v-btn @click="confirmActivate = false" :disabled="loading" variant="outlined">
                Cancel
            </v-btn>
            <v-btn :loading="loading" @click="activateAnnouncement()" color="darkGreen" variant="elevated">
                Confirm
            </v-btn>
            </template>
        </v-card>
    </v-dialog>

    <AnnouncementDialog ref="AnnouncementDialog" @refresh="init()"/>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue'
import AnnouncementDialog from '../Dialogs/AnnouncementDialog.vue';
import { useSnackbar } from '@/composables/useSnackbar'

export default defineComponent({
    components: {
        AnnouncementDialog
    },
    data () {
        return {
            data: [],
            search: null,
            loading: false,

            confirmActivate: false,
            idToActivate: null,

            headers: [
                { title: 'Details', align: 'start', sortable: true, key: 'details' },
                { title: 'Is Active', align: 'start', sortable: true, key: 'is_active' },
                { title: 'Date Created', align: 'start', sortable: true, key: 'datecreated' },
                { title: 'Actions', align: 'end', sortable: false, key: 'action' },
            ],
        }
    },
    methods: {
        init(){
            this.loading = true
            const token = localStorage.getItem('aums-token')
            axios.get(process.env.VUE_APP_SERVER_URL + '/announcements',
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.loading = false
                    this.data = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false
                    
                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        activateAnnouncement(){
            const { showSnackbar } = useSnackbar()
            const token = localStorage.getItem('aums-token')
            axios.post(process.env.VUE_APP_SERVER_URL + '/announcements/activateAnnouncement/' + this.idToActivate,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data.status == 200){
                    this.loading = false
                    this.$emit('refresh')
                    showSnackbar('Announcement successfully activated!')
                    this.confirmActivate = false
                    this.init()
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false
                    showSnackbar('Token expired! Logging out..')

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            })
        },
        showAddDialog(){
            this.$refs.AnnouncementDialog.initAdd()
        },
        showEditDialog(data){
            this.$refs.AnnouncementDialog.initUpdate(data)
        },
        showActivateDialog(data){
            this.idToActivate = data.id
            this.confirmActivate = true
        }
    },
    mounted(){
        this.init()
    }
})
</script>

<style scoped>

</style>